var _jsxFileName = "/codebuild/output/src3324671287/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/RichText/Link.tsx";
import React from 'react';
import { Text } from '@adc/parallax-component-library';
export const Link = ({
  onPressLink,
  href,
  target,
  children
}) => {
  return /*#__PURE__*/React.createElement(Text, {
    tag: "a"
    // @ts-expect-error no `rel` property
    ,
    rel: "noreferrer",
    href: href,
    target: target,
    type: "$bodyBase.default",
    color: "$interactive.core.enabled",
    style: {
      textDecorationLine: 'none'
    },
    onPress: e => {
      if (onPressLink && href && !(href !== null && href !== void 0 && href.startsWith('https'))) {
        e.preventDefault();
        onPressLink(href);
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }, children);
};